Label = require 'app/scripts/models/label'
LabelEditComponent = require 'app/scripts/views/label/label-edit-component'
LabelLimitsErrorView = require 'app/scripts/views/label/label-limits-error-view'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'

module.exports = class LabelCreateView extends View
  viewTitleKey: 'create label'

  el: ->
    if @options.board.isOverLimit('labels', 'perBoard')
      return new LabelLimitsErrorView().render().el
    color = @options.color
    name = @options.name
    if name in Label.colors
      color = name
      name = ''
    new LabelEditComponent
      model: { name: name }
      submitTextKey: 'create'
      color: color
      onSubmit: (name, color) =>
        if @options.board.isOverLimit('labels', 'perBoard')
          PopOver.pushView(new LabelLimitsErrorView())
          return
        @options.onSubmit?(name, color)
        PopOver.popView()
    .render()
    .el
